'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _calendars = require('redux/modules/calendars');

var actions = _interopRequireWildcard(_calendars);

var _components = require('components');

var _can = require('helpers/can');

var _can2 = _interopRequireDefault(_can);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarOptionsForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    calendar: state.calendars.calendar,
    loaded: state.calendars.loaded,
    loading: state.calendars.loading,
    saving: state.calendars.saving,
    saveError: state.calendars.saveError,
    taxonomies: state.taxonomies.taxonomies.data,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, actions), null, { withRef: true }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(CalendarOptionsForm, _Component);

  function CalendarOptionsForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CalendarOptionsForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarOptionsForm.__proto__ || (0, _getPrototypeOf2.default)(CalendarOptionsForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      autofocus: false,
      calendar: _this.props.calendar,
      eventHasChanged: false,
      popoverContainer: null,
      showCloseModalPopover: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CalendarOptionsForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          calendarId = _props.calendarId,
          find = _props.find; // eslint-disable-line no-shadow

      if (calendarId) {
        find(calendarId);
      } else {
        // Should not happen
        this.handleCloseModal();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        calendar: nextProps.calendar
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.removeErrors();
    }
  }, {
    key: 'handleAddUser',
    value: function handleAddUser(user, role) {
      var newUser = {
        id: user.id,
        name: user.name,
        email: user.email,
        role: role
      };

      var calendar = this.state.calendar;


      calendar = (0, _reactAddonsUpdate2.default)(calendar, {
        $merge: {
          calendarHasChanged: true,
          users: calendar.users.concat([newUser])
        }
      });

      this.updateCalendarState(calendar);
    }
  }, {
    key: 'handleEditUser',
    value: function handleEditUser(userId, role) {
      var intUserId = parseInt(userId, 10);

      var calendar = this.state.calendar;


      var user = calendar.users.find(function (item) {
        return item.id === intUserId;
      });
      var userIndex = calendar.users.indexOf(user);

      if (userIndex === -1) {
        return;
      }

      if (calendar.users[userIndex].role === role) {
        return;
      }

      calendar.users[userIndex].role = role;

      calendar = (0, _reactAddonsUpdate2.default)(calendar, {
        $merge: {
          calendarHasChanged: true,
          users: calendar.users
        }
      });

      this.updateCalendarState(calendar);
    }
  }, {
    key: 'handleRemoveUser',
    value: function handleRemoveUser(userId) {
      var intUserId = parseInt(userId, 10);

      var calendar = this.state.calendar;


      var user = calendar.users.find(function (item) {
        return item.id === intUserId;
      });
      var userIndex = calendar.users.indexOf(user);

      if (userIndex === -1) {
        return;
      }

      calendar.users.splice(userIndex, 1);
      calendar = (0, _reactAddonsUpdate2.default)(calendar, {
        $merge: {
          calendarHasChanged: true,
          users: calendar.users
        }
      });

      this.updateCalendarState(calendar);
    }
  }, {
    key: 'handleChangeName',
    value: function handleChangeName(ev) {
      var calendar = this.state.calendar;


      calendar = (0, _reactAddonsUpdate2.default)(calendar, {
        $merge: {
          name: ev.target.value
        }
      });

      this.updateCalendarState(calendar);
    }
  }, {
    key: 'handleChangeIntegrationMarkup',
    value: function handleChangeIntegrationMarkup(ev) {
      var calendar = this.state.calendar;


      calendar = (0, _reactAddonsUpdate2.default)(calendar, {
        $merge: {
          integrationjs_markup: ev.target.value
        }
      });

      this.updateCalendarState(calendar);
    }
  }, {
    key: 'handleChangeIntegrationStyle',
    value: function handleChangeIntegrationStyle(ev) {
      var calendar = this.state.calendar;


      calendar = (0, _reactAddonsUpdate2.default)(calendar, {
        $merge: {
          integrationjs_style: ev.target.value
        }
      });

      this.updateCalendarState(calendar);
    }
  }, {
    key: 'handleChangeCalendarOptions',
    value: function handleChangeCalendarOptions(option) {
      var calendar = this.state.calendar;


      calendar = (0, _reactAddonsUpdate2.default)(calendar, {
        options: {
          $merge: option
        }
      });

      this.updateCalendarState(calendar);
    }
  }, {
    key: 'handleChangeTaxonomy',
    value: function handleChangeTaxonomy(id, checked) {
      var calendar = this.state.calendar;


      var taxonomies = calendar.taxonomies.filter(function (tax) {
        return tax.id !== id;
      });

      if (checked) {
        taxonomies.push({
          id: id
        });
      }

      calendar = (0, _reactAddonsUpdate2.default)(calendar, {
        taxonomies: {
          $set: taxonomies
        }
      });

      this.updateCalendarState(calendar);
    }
  }, {
    key: 'updateCalendarState',
    value: function updateCalendarState(calendar) {
      this.setState({
        calendar: calendar,
        calendarHasChanged: true
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this2 = this;

      var save = this.props.save;
      var calendar = this.state.calendar;


      save(calendar).then(function (res) {
        if (res && res.type === actions.SAVE_SUCCESS) {
          _this2.handleCloseModal();
        }
      });
    }
  }, {
    key: 'showCloseModalPopover',
    value: function showCloseModalPopover() {
      this.setState({
        showCloseModalPopover: true
      });
    }
  }, {
    key: 'handleCloseModal',
    value: function handleCloseModal() {
      this.props.closeModal();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          loaded = _props2.loaded,
          loading = _props2.loading,
          polyglot = _props2.polyglot,
          requireCloseModal = _props2.requireCloseModal,
          saving = _props2.saving,
          saveError = _props2.saveError,
          taxonomies = _props2.taxonomies,
          user = _props2.user;
      var calendar = this.state.calendar;

      // const popoverContainer = this;

      var hasErrors = saveError && saveError[calendar.id];
      var errorMessage = hasErrors ? polyglot.t('errors.' + saveError[calendar.id].status_code) : '';
      var errorFields = hasErrors ? saveError[calendar.id].errors : '';

      return _react2.default.createElement(
        _components.Loader,
        { loaded: !loading && loaded },
        _react2.default.createElement(
          'div',
          { className: 'modal-body' },
          _react2.default.createElement(
            'div',
            { className: 'calendar-options-form' },
            _react2.default.createElement(
              _reactBootstrap.OverlayTrigger,
              {
                trigger: 'click',
                placement: 'bottom',
                rootClose: true,
                overlay: _react2.default.createElement(
                  _reactBootstrap.Popover,
                  { id: 'closeModalPopover', className: 'closeform-box-popover' },
                  _react2.default.createElement(_components.CloseModalPopover, { close: this.handleCloseModal.bind(this), save: this.handleSave.bind(this), saving: saving, scope: 'calendars', polyglot: polyglot })
                )
              },
              _react2.default.createElement('button', {
                type: 'button',
                onClick: requireCloseModal,
                className: 'close-modal-button icon-cg-close'
              })
            ),
            _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement('input', {
                type: 'text',
                id: 'calendar-name-box',
                className: 'form-control input-h1' + (errorFields && errorFields.name ? ' has-error' : ''),
                onChange: this.handleChangeName.bind(this),
                defaultValue: calendar.name,
                disabled: true,
                autoFocus: this.state.autofocus,
                placeholder: polyglot.t('calendars.nameBox.help')
              })
            ),
            _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement(
                _reactBootstrap.Col,
                { md: 12 },
                _react2.default.createElement(_components.IntegrationJsBox, {
                  markup: calendar.integrationjs_markup,
                  style: calendar.integrationjs_style,
                  onChangeMarkup: this.handleChangeIntegrationMarkup.bind(this),
                  onChangeStyle: this.handleChangeIntegrationStyle.bind(this),
                  polyglot: polyglot
                })
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement(
                _reactBootstrap.Col,
                { md: 12 },
                _react2.default.createElement(_components.CalendarFormOptionsBox, {
                  calendar: calendar,
                  onChangeOptions: this.handleChangeCalendarOptions.bind(this),
                  onChangeTaxonomy: this.handleChangeTaxonomy.bind(this),
                  taxonomies: taxonomies,
                  polyglot: polyglot,
                  superadmin: (0, _can2.default)('super_admin', user)
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-md-12' },
                (0, _can2.default)('admin', [calendar]) && calendar.users && _react2.default.createElement(
                  'div',
                  { ref: 'userRoleSelectorContainer' },
                  _react2.default.createElement(_components.UserRoleSelector, {
                    calendarId: this.props.calendarId,
                    users: calendar.users,
                    inheritedUsers: calendar.inheritedUsers,
                    addUser: this.handleAddUser.bind(this),
                    editUser: this.handleEditUser.bind(this),
                    removeUser: this.handleRemoveUser.bind(this),
                    except: calendar.users.map(function (_ref2) {
                      var id = _ref2.id;
                      return id;
                    }),
                    polyglot: polyglot
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'modal-footer' },
          _react2.default.createElement(
            'div',
            { className: 'pull-right' },
            _react2.default.createElement(
              'span',
              { className: 'status-label label label-danger' },
              errorMessage
            ),
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary',
                onClick: !saving ? this.handleSave.bind(this) : null,
                disabled: saving
              },
              saving ? _react2.default.createElement('i', { className: 'glyphicon glyphicon-refresh cg-spinner' }) : '',
              ' ',
              polyglot.t('events.form.save')
            )
          )
        )
      );
    }
  }]);
  return CalendarOptionsForm;
}(_react.Component), _class2.propTypes = {
  calendarId: _propTypes2.default.number,
  closeModal: _propTypes2.default.func,
  calendar: _propTypes2.default.object,
  loaded: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  find: _propTypes2.default.func,
  polyglot: _propTypes2.default.object.isRequired,
  removeErrors: _propTypes2.default.func,
  requireCloseModal: _propTypes2.default.func,
  save: _propTypes2.default.func.isRequired,
  saving: _propTypes2.default.bool,
  saveError: _propTypes2.default.object,
  taxonomies: _propTypes2.default.array.isRequired,
  user: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = CalendarOptionsForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Calendar/CalendarOptionsForm.js
// module id = 2190
// module chunks = 0